import api from './api';

export interface ExportableEntity {
  key: string;
  label: string;
  order: number;
}

export interface ImportOptions {
  entities?: string[] | null;
  strategy?: 'skip_existing' | 'overwrite' | 'fail_on_conflict';
}

export interface ImportResult {
  imported: Record<string, { old_id: number; new_id: number; action?: string }[]>;
  skipped: Record<string, { old_id: number; name: string }[]>;
  errors: string[];
}

export const importExportService = {
  getExportableEntities: async (): Promise<ExportableEntity[]> => {
    const response = await api.get('/import-export/entities');
    return response.data;
  },

  exportData: async (
    entities: string[],
    filters?: Record<string, number | string | null>,
    includeDependencies: boolean = true
  ): Promise<Blob> => {
    const response = await api.post(
      '/import-export/export',
      { entities, filters: filters || {}, include_dependencies: includeDependencies },
      { responseType: 'blob' }
    );
    return response.data as Blob;
  },

  importData: async (
    file: File,
    options: ImportOptions = {}
  ): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'options',
      JSON.stringify({
        entities: options.entities ?? null,
        strategy: options.strategy ?? 'skip_existing',
      })
    );
    const response = await api.post('/import-export/import', formData);
    return response.data;
  },
};
